import React from 'react';
import ReactDOM from 'react-dom';

import type { Initializer } from 'common/types/initializers';
import { Reconnect } from 'src/federation/Reconnect';
import { getOrAppendChild } from 'utilities/DOM/getOrAppendChild';

export const ClientAppointmentsModalInitializer = (props: {
  onClose: () => void;
  clientId: number;
}): Initializer => {
  const node = getOrAppendChild({
    id: 'client-appointments-modal',
    parentNode: document.body,
  });

  const destroy = () => ReactDOM.unmountComponentAtNode(node);
  const onClose = () => {
    props.onClose();
    destroy();
  };

  return {
    destroy,
    render: () => {
      ReactDOM.render(
        <Reconnect
          name="ClientAppointmentsModal"
          props={{
            onClose,
            clientId: props.clientId,
          }}
        />,
        node,
      );
    },
  };
};
